import styled from 'styled-components';

export const StyledNewStripePaymentMethodForm = styled.div`
  .save-card-check {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;
  }

  .payment-form {
    min-height: 180px;
    position: relative;
    .loader {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: center;
      width: 100%;
    }
  }
  .pay-button {
    font-size: 20px;
    line-height: 24px;
  }
`;
